export default __webpack_public_path__ + "static/media/gear.765e24c7.svg";